export const PARAMS_KEY = {
  email: 'cardholderEmail',
  total: 'total',
  subtotal: 'subtotal',
  discount: 'discount',
};
